import React, { useState, useEffect } from "react";
import axios from "axios";
import "./FormInput.css";
import FormInput from "./FormInput";
// import { useNavigate } from "react-router-dom";
// import Protected from "./Protected";
const Login = () => {
  const [values, setValues] = useState({
    email: "",
    password: ""
  });
  const [isLogging, setIsLogging] = useState(false);
  const inputs = [
    {
      id: 2,
      name: "email",
      type: "email",
      placeholder: "Email",
      errorMessage: "It should be a valid email address!",
      label: "Email",
      required: true
    },
    {
      id: 4,
      name: "password",
      type: "password",
      placeholder: "Password",
      errorMessage: "Please enter correct password",
      label: "Password",
      required: true,
      pattern:
        "^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$"
    }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLogging(true);
    const { email, password } = values;

    axios
      .post("http://localhost:5000/login-user", {
        email,
        password
      })
      .then((response) => {
        const data = response.data;
        console.log(data, "userRegister");
        if (data.status === "ok") {
          window.localStorage.setItem("token", data.data);
          window.localStorage.setItem("loggedIn", true);
          window.location.href = "./Feed";
        } else if (data.status === "error") {
          alert(
            "Username and password do not match. Please ensure you have entered the correct credentials."
          );
        }
      })
      .catch((error) => {
        alert("An error occurred during login", error);
        alert("Login failed");
      })
      .finally(() => {
        setIsLogging(false);
      });
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  console.log(values);

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h1 className="headings">Login</h1>
        {inputs.map((input) => (
          <FormInput
            className="login-form form-input"
            key={input.id}
            {...input}
            value={values[input.name]}
            onChange={onChange}
          />
        ))}
        <button
          // onClick={login}
          className="login-form"
          type="submit"
          disabled={isLogging}
        >
          {isLogging ? "Logging..." : "Submit"}
        </button>
        <p>
          Need an Account? <a href="Register">SignUp</a>
        </p>
      </form>
    </div>
  );
};

export default Login;
